module.exports = __webpack_public_path__ + "static/media/group--high-heat--dark.31182cf7.svg";